var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMadi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 29,
    viewBox: "0 0 120 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2912_7902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29V4.46155H6.72897L17.9439 24.5385L29.1589 4.46155H35.8878V29H29.1589V11.1539L20.1869 29H15.7009L6.72897 11.1539V29H0Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.908 8.92309C105.802 6.60556 103.581 4.91762 100.935 4.54086C100.568 4.48881 100.194 4.46155 99.8131 4.46155H80.7476H78.5047H74.0187V29H78.5047H80.7476H99.8131C100.194 29 100.568 28.9727 100.935 28.9207C103.581 28.5439 105.802 26.856 106.908 24.5385C107.392 23.5247 107.664 22.3895 107.664 21.1923V12.2692C107.664 11.0721 107.392 9.93685 106.908 8.92309ZM100.935 20.0769C100.935 22.5407 98.9258 24.5385 96.4486 24.5385H80.7476V8.92309H96.4486C98.9258 8.92309 100.935 10.9209 100.935 13.3846V20.0769Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.128 11.1538H111.9V29H119.128V11.1538Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.514 8.92308C117.992 8.92308 120 6.92558 120 4.46154C120 1.9975 117.992 0 115.514 0C113.037 0 111.028 1.9975 111.028 4.46154C111.028 6.92558 113.037 8.92308 115.514 8.92308Z",
    fill: "url(#paint0_radial_2912_7902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8781 8.77546L51.9111 8.77546L50.7843 8.77546C48.2952 8.77546 46.2769 10.7773 46.2769 13.2461L46.2769 29L39.9999 29L39.9999 12.6909C39.9999 12.3109 40.0275 11.9383 40.0801 11.5732C40.4607 8.93558 42.166 6.33182 44.5073 5.22907C45.5315 4.74724 46.6783 4.47652 47.8878 4.47652L61.72 4.47652C62.9294 4.47652 64.0763 4.74724 65.1005 5.22907C67.4418 6.33182 69.147 8.93558 69.5277 11.5732C69.5802 11.9383 69.6078 12.3109 69.6078 12.6909L69.6078 29L63.5123 29L63.5123 13.2461C63.5123 10.7773 61.494 8.77546 59.005 8.77546L57.8781 8.77546Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7843,
    y: 24.7181,
    width: 27.6471,
    height: 4.28188,
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2912_7902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.591 3.15282) scale(5.76818 5.73675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4C74B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2912_7902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMadi);
export default __webpack_public_path__ + "static/media/Logo_Madi.9fa163bf4e8eb688e7a540d8ca307e72.svg";
export { ForwardRef as ReactComponent };